import { Component } from '@angular/core';

@Component({
    selector: 'app-accessibility-statement',
    templateUrl: './accessibility-statement.component.html',
    styleUrls: ['./accessibility-statement.component.scss'],
  standalone: true,
  imports: []
})
export class AccessibilityStatementComponent {
}
